import * as ambassadorWixVeloSecretsVaultV1Secret from './velo-secrets-vault-v1-secret-secrets.http.js';
import * as ambassadorWixVeloSecretsVaultV1SecretTypes from './velo-secrets-vault-v1-secret-secrets.types.js';
import * as ambassadorWixVeloSecretsVaultV1SecretUniversalTypes from './velo-secrets-vault-v1-secret-secrets.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getSecretValue(): __PublicMethodMetaInfo<
  'GET',
  { name: string },
  ambassadorWixVeloSecretsVaultV1SecretUniversalTypes.GetSecretValueRequest,
  ambassadorWixVeloSecretsVaultV1SecretTypes.GetSecretValueRequest,
  ambassadorWixVeloSecretsVaultV1SecretUniversalTypes.GetSecretValueResponse,
  ambassadorWixVeloSecretsVaultV1SecretTypes.GetSecretValueResponse
> {
  const payload = { name: ':name' } as any;

  const getRequestOptions =
    ambassadorWixVeloSecretsVaultV1Secret.getSecretValue(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/api/v1/secrets/name/{name}',
    pathParams: { name: 'name' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listSecretInfo(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixVeloSecretsVaultV1SecretUniversalTypes.ListSecretInfoRequest,
  ambassadorWixVeloSecretsVaultV1SecretTypes.ListSecretInfoRequest,
  ambassadorWixVeloSecretsVaultV1SecretUniversalTypes.ListSecretInfoResponse,
  ambassadorWixVeloSecretsVaultV1SecretTypes.ListSecretInfoResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixVeloSecretsVaultV1Secret.listSecretInfo(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/api/v1/secrets',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createSecret(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixVeloSecretsVaultV1SecretUniversalTypes.CreateSecretRequest,
  ambassadorWixVeloSecretsVaultV1SecretTypes.CreateSecretRequest,
  ambassadorWixVeloSecretsVaultV1SecretUniversalTypes.CreateSecretResponse,
  ambassadorWixVeloSecretsVaultV1SecretTypes.CreateSecretResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixVeloSecretsVaultV1Secret.createSecret(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/api/v1/secrets',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteSecret(): __PublicMethodMetaInfo<
  'DELETE',
  { id: string },
  ambassadorWixVeloSecretsVaultV1SecretUniversalTypes.DeleteSecretRequest,
  ambassadorWixVeloSecretsVaultV1SecretTypes.DeleteSecretRequest,
  ambassadorWixVeloSecretsVaultV1SecretUniversalTypes.DeleteSecretResponse,
  ambassadorWixVeloSecretsVaultV1SecretTypes.DeleteSecretResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixVeloSecretsVaultV1Secret.deleteSecret(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/api/v1/secrets/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateSecret(): __PublicMethodMetaInfo<
  'PATCH',
  { id: string },
  ambassadorWixVeloSecretsVaultV1SecretUniversalTypes.UpdateSecretRequest,
  ambassadorWixVeloSecretsVaultV1SecretTypes.UpdateSecretRequest,
  ambassadorWixVeloSecretsVaultV1SecretUniversalTypes.UpdateSecretResponse,
  ambassadorWixVeloSecretsVaultV1SecretTypes.UpdateSecretResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixVeloSecretsVaultV1Secret.partiallyUpdateSecret(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/api/v1/secrets/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Secret as SecretOriginal,
  GetSecretValueRequest as GetSecretValueRequestOriginal,
  GetSecretValueResponse as GetSecretValueResponseOriginal,
  ListSecretInfoRequest as ListSecretInfoRequestOriginal,
  ListSecretInfoResponse as ListSecretInfoResponseOriginal,
  CreateSecretRequest as CreateSecretRequestOriginal,
  CreateSecretResponse as CreateSecretResponseOriginal,
  DeleteSecretRequest as DeleteSecretRequestOriginal,
  DeleteSecretResponse as DeleteSecretResponseOriginal,
  UpdateSecretRequest as UpdateSecretRequestOriginal,
  UpdateSecretResponse as UpdateSecretResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './velo-secrets-vault-v1-secret-secrets.types.js';
